const MARKETS_LIST = {
  taiwan: { cms: "twi", central: "tw", locale: "zh-tw", lang: "zh-Hant"  },
  switzerland_german: { cms: "chd", central: "cs", locale: "de-ch", lang: "de-CH"  },
  switzerland_french: { cms: "chf", central: "ch", locale: "fr-ch", lang: "fr-CH"  },
  poland: { cms: "plw", central: "pl", locale: "pl-pl", lang: "pl"  },
  spanish: { cms: "esb", central: "es", locale: "es-es", lang: "es-ES"  },
  norwegian: { cms: "noo", central: "no", locale: "no-no", lang: "no"  },
  dutch: { cms: "nla", central: "nl", locale: "nl-nl", lang: "nl"  },
  korean: { cms: "krs", central: "kr", locale: "ko", lang: "ko"  },
  japanese: { cms: "jpt" , central: "jp", locale: "ja", lang: "ja" },
  italian: { cms: "itm", central: "it", locale: "it-it", lang: "it"  },
  danish: { cms: "dkc", central: "dk", locale: "da", lang: "da"  },
  austria_german: { cms: "atv", central: "at", locale: "de-at", lang: "de-AT"  },
  french: { cms: "frp", central: "fr", locale: "fr-fr", lang: "fr-FR"  },
  swedish: { cms: "ses", central: "se", locale: "sv-se", lang: "sv" },
  german: { cms: "deb", central: "de", locale: "de-de", lang: "de"  },
  belgium_french: { cms: "beb", central: "be", locale: "fr-be", lang: "fr-BE"  },
  belgium_dutch: { cms: "bna", central: "bx", locale: "nl-be", lang: "nl-BE"  },
  brazil_portuguese: { cms: "brs", central: "br", locale: "pt-br", lang: "pt-BR"  },
};

const SERVICE_ENV = {
  prod: "www.ef.com",
  qa: "qa.ef.com",
};

module.exports = {
  MARKETS_LIST,
  SERVICE_ENV,
};
